/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 3:34:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { BillingConfigurationListView } from "service-builder/components/billing";

export const BillingConfigurationsListPage = () => {
  return (
    <div className="os-service-builder-card">
      <BillingConfigurationListView />
    </div>
  );
};
